const settings = {
    PHP_API_WEB_ROOT: '/php/menu/'
};

export default settings;
